import { QRCodeSVG } from "qrcode.react";
import styles from "./LoyaltyQrCode.module.scss";

interface LoyaltyQrCodeProps {
  /** What the waiter's scanner reads. */
  value: string;
  size?: number;
}

/**
 * The redemption code a guest shows a waiter.
 *
 * Plain black on white, like the RMS's table-card code. No logo punched into
 * the middle: the mark rendered as a white patch with a stray exclamation
 * mark, which looked broken and cost error-correction budget for nothing.
 * Error correction stays at "H" so a scuffed or half-lit screen still scans.
 */
function LoyaltyQrCode(props: LoyaltyQrCodeProps) {
  const { value, size = 220 } = props;

  return (
    <div className={styles.qrCodeWrapper}>
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        fgColor="#000000"
        bgColor="#ffffff"
      />
    </div>
  );
}

export default LoyaltyQrCode;
